import { useEffect } from 'react';

/** Add only our tenant icon, then remove it on workspace change or sign-out. */
export function useFirmFavicon(value: unknown) {
  useEffect(() => {
    if (
      typeof value !== 'string' ||
      !value.startsWith('data:image/png;base64,')
    )
      return;
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/png';
    icon.href = value;
    icon.dataset.firmFavicon = 'true';
    document.head.append(icon);
    return () => icon.remove();
  }, [value]);
}
